{
  "version": 1,
  "method": "Bagged Kriging with External Drift",
  "why": "Uses trial & error with real samples to accurately differentiate between broad- and small-scale field variation.",
  "models": [
    {
      "key": "OM",
      "label": "OM",
      "nFeatures": 822,
      "classes": [
        {
          "cls": "SSURGO (soil)",
          "pct": 38.4,
          "n": 21,
          "subs": [
            {
              "sub": "OM",
              "pct": 9.9
            },
            {
              "sub": "Soil map unit",
              "pct": 6.5
            },
            {
              "sub": "Series",
              "pct": 4.4
            },
            {
              "sub": "CEC",
              "pct": 4
            }
          ]
        },
        {
          "cls": "Weather / climate",
          "pct": 27.9,
          "n": 574,
          "subs": [
            {
              "sub": "Precip",
              "pct": 5.7
            },
            {
              "sub": "Solar",
              "pct": 4.4
            },
            {
              "sub": "Deriv",
              "pct": 3.2
            },
            {
              "sub": "GDD",
              "pct": 3
            }
          ]
        },
        {
          "cls": "NDVI / vegetation",
          "pct": 14.2,
          "n": 30,
          "subs": [
            {
              "sub": "Peak",
              "pct": 3.1
            },
            {
              "sub": "Prev fall",
              "pct": 2.7
            },
            {
              "sub": "Integral",
              "pct": 2.6
            },
            {
              "sub": "Spring",
              "pct": 1.9
            }
          ]
        },
        {
          "cls": "Topographic",
          "pct": 13.5,
          "n": 15,
          "subs": [
            {
              "sub": "HAND",
              "pct": 3.9
            },
            {
              "sub": "Elevation",
              "pct": 3.1
            },
            {
              "sub": "Wetness",
              "pct": 2.6
            },
            {
              "sub": "Aspect",
              "pct": 1.1
            }
          ]
        },
        {
          "cls": "Crop history (CDL)",
          "pct": 2.8,
          "n": 12,
          "subs": [
            {
              "sub": "Rotation",
              "pct": 0.8
            },
            {
              "sub": "Distinct",
              "pct": 0.8
            },
            {
              "sub": "Crop",
              "pct": 0.6
            },
            {
              "sub": "CDL",
              "pct": 0.4
            }
          ]
        },
        {
          "cls": "Cover crop",
          "pct": 2.3,
          "n": 11,
          "subs": [
            {
              "sub": "Prob",
              "pct": 1.4
            },
            {
              "sub": "Window",
              "pct": 0.6
            },
            {
              "sub": "Cover",
              "pct": 0.3
            }
          ]
        },
        {
          "cls": "Machine data",
          "pct": 0.9,
          "n": 159,
          "subs": [
            {
              "sub": "Seedrate",
              "pct": 0.4
            },
            {
              "sub": "Moisture",
              "pct": 0.2
            },
            {
              "sub": "Appl",
              "pct": 0.2
            },
            {
              "sub": "Yield",
              "pct": 0.2
            }
          ]
        }
      ]
    },
    {
      "key": "pH",
      "label": "pH",
      "nFeatures": 817,
      "classes": [
        {
          "cls": "Weather / climate",
          "pct": 41.3,
          "n": 575,
          "subs": [
            {
              "sub": "Solar",
              "pct": 8.8
            },
            {
              "sub": "Precip",
              "pct": 6.3
            },
            {
              "sub": "Soil wetness",
              "pct": 6.1
            },
            {
              "sub": "GDD",
              "pct": 5.2
            }
          ]
        },
        {
          "cls": "NDVI / vegetation",
          "pct": 26.4,
          "n": 30,
          "subs": [
            {
              "sub": "Prev fall",
              "pct": 5.2
            },
            {
              "sub": "Peak",
              "pct": 4.4
            },
            {
              "sub": "Grain fill",
              "pct": 4.3
            },
            {
              "sub": "Spring",
              "pct": 4.1
            }
          ]
        },
        {
          "cls": "Topographic",
          "pct": 14.3,
          "n": 15,
          "subs": [
            {
              "sub": "Wetness",
              "pct": 3.2
            },
            {
              "sub": "Aspect",
              "pct": 2.7
            },
            {
              "sub": "Elevation",
              "pct": 2.5
            },
            {
              "sub": "Curvature",
              "pct": 2.1
            }
          ]
        },
        {
          "cls": "SSURGO (soil)",
          "pct": 7.9,
          "n": 19,
          "subs": [
            {
              "sub": "Soil map unit",
              "pct": 2
            },
            {
              "sub": "Series",
              "pct": 0.7
            },
            {
              "sub": "Sand",
              "pct": 0.6
            },
            {
              "sub": "pH",
              "pct": 0.6
            }
          ]
        },
        {
          "cls": "Cover crop",
          "pct": 5.3,
          "n": 11,
          "subs": [
            {
              "sub": "Prob",
              "pct": 3.5
            },
            {
              "sub": "Window",
              "pct": 1.2
            },
            {
              "sub": "Cover",
              "pct": 0.6
            }
          ]
        },
        {
          "cls": "Crop history (CDL)",
          "pct": 2.9,
          "n": 12,
          "subs": [
            {
              "sub": "CDL",
              "pct": 1.1
            },
            {
              "sub": "Rotation",
              "pct": 0.6
            },
            {
              "sub": "Crop",
              "pct": 0.5
            },
            {
              "sub": "Distinct",
              "pct": 0.4
            }
          ]
        },
        {
          "cls": "Machine data",
          "pct": 1.9,
          "n": 155,
          "subs": [
            {
              "sub": "Seedrate",
              "pct": 0.5
            },
            {
              "sub": "Moisture",
              "pct": 0.5
            },
            {
              "sub": "Yield",
              "pct": 0.3
            },
            {
              "sub": "Appl",
              "pct": 0.3
            }
          ]
        }
      ]
    },
    {
      "key": "P",
      "label": "P",
      "nFeatures": 828,
      "classes": [
        {
          "cls": "Weather / climate",
          "pct": 45.3,
          "n": 575,
          "subs": [
            {
              "sub": "Precip",
              "pct": 9.1
            },
            {
              "sub": "Solar",
              "pct": 7.1
            },
            {
              "sub": "GDD",
              "pct": 6.2
            },
            {
              "sub": "Tmax",
              "pct": 5
            }
          ]
        },
        {
          "cls": "NDVI / vegetation",
          "pct": 18.1,
          "n": 31,
          "subs": [
            {
              "sub": "Integral",
              "pct": 3.4
            },
            {
              "sub": "Prev fall",
              "pct": 3.3
            },
            {
              "sub": "Spring",
              "pct": 2.8
            },
            {
              "sub": "Peak",
              "pct": 2.7
            }
          ]
        },
        {
          "cls": "SSURGO (soil)",
          "pct": 16.1,
          "n": 25,
          "subs": [
            {
              "sub": "Soil map unit",
              "pct": 4
            },
            {
              "sub": "Map unit",
              "pct": 2.2
            },
            {
              "sub": "Sand",
              "pct": 1.4
            },
            {
              "sub": "Silt",
              "pct": 1.2
            }
          ]
        },
        {
          "cls": "Topographic",
          "pct": 10.5,
          "n": 15,
          "subs": [
            {
              "sub": "Wetness",
              "pct": 3.1
            },
            {
              "sub": "Aspect",
              "pct": 1.6
            },
            {
              "sub": "HAND",
              "pct": 1.6
            },
            {
              "sub": "Curvature",
              "pct": 1.5
            }
          ]
        },
        {
          "cls": "Cover crop",
          "pct": 3.8,
          "n": 11,
          "subs": [
            {
              "sub": "Prob",
              "pct": 2.2
            },
            {
              "sub": "Window",
              "pct": 1
            },
            {
              "sub": "Cover",
              "pct": 0.6
            }
          ]
        },
        {
          "cls": "Crop history (CDL)",
          "pct": 3.5,
          "n": 12,
          "subs": [
            {
              "sub": "CDL",
              "pct": 1.1
            },
            {
              "sub": "Rotation",
              "pct": 0.9
            },
            {
              "sub": "Distinct",
              "pct": 0.8
            },
            {
              "sub": "Crop",
              "pct": 0.4
            }
          ]
        },
        {
          "cls": "Machine data",
          "pct": 2.6,
          "n": 159,
          "subs": [
            {
              "sub": "Appl",
              "pct": 0.7
            },
            {
              "sub": "Seedrate",
              "pct": 0.5
            },
            {
              "sub": "Moisture",
              "pct": 0.4
            },
            {
              "sub": "Yield",
              "pct": 0.3
            }
          ]
        }
      ]
    },
    {
      "key": "K",
      "label": "K",
      "nFeatures": 828,
      "classes": [
        {
          "cls": "Weather / climate",
          "pct": 46.2,
          "n": 575,
          "subs": [
            {
              "sub": "Precip",
              "pct": 8.9
            },
            {
              "sub": "Solar",
              "pct": 7.5
            },
            {
              "sub": "Deriv",
              "pct": 6
            },
            {
              "sub": "GDD",
              "pct": 5.8
            }
          ]
        },
        {
          "cls": "NDVI / vegetation",
          "pct": 19.6,
          "n": 30,
          "subs": [
            {
              "sub": "Prev fall",
              "pct": 4
            },
            {
              "sub": "Peak",
              "pct": 3.2
            },
            {
              "sub": "Integral",
              "pct": 2.9
            },
            {
              "sub": "Spring",
              "pct": 2.9
            }
          ]
        },
        {
          "cls": "SSURGO (soil)",
          "pct": 12.3,
          "n": 24,
          "subs": [
            {
              "sub": "Soil map unit",
              "pct": 3.8
            },
            {
              "sub": "Series",
              "pct": 1.4
            },
            {
              "sub": "OM",
              "pct": 0.8
            },
            {
              "sub": "Sand",
              "pct": 0.7
            }
          ]
        },
        {
          "cls": "Topographic",
          "pct": 10.9,
          "n": 15,
          "subs": [
            {
              "sub": "Wetness",
              "pct": 3.2
            },
            {
              "sub": "Aspect",
              "pct": 1.7
            },
            {
              "sub": "Curvature",
              "pct": 1.6
            },
            {
              "sub": "Elevation",
              "pct": 1.4
            }
          ]
        },
        {
          "cls": "Crop history (CDL)",
          "pct": 4.9,
          "n": 12,
          "subs": [
            {
              "sub": "CDL",
              "pct": 1.5
            },
            {
              "sub": "Distinct",
              "pct": 1.1
            },
            {
              "sub": "Rotation",
              "pct": 1.1
            },
            {
              "sub": "Crop",
              "pct": 0.6
            }
          ]
        },
        {
          "cls": "Cover crop",
          "pct": 4.2,
          "n": 11,
          "subs": [
            {
              "sub": "Prob",
              "pct": 2.5
            },
            {
              "sub": "Window",
              "pct": 1
            },
            {
              "sub": "Cover",
              "pct": 0.8
            }
          ]
        },
        {
          "cls": "Machine data",
          "pct": 1.8,
          "n": 161,
          "subs": [
            {
              "sub": "Seedrate",
              "pct": 0.4
            },
            {
              "sub": "Appl",
              "pct": 0.4
            },
            {
              "sub": "Moisture",
              "pct": 0.3
            },
            {
              "sub": "Yield",
              "pct": 0.3
            }
          ]
        }
      ]
    },
    {
      "key": "CEC",
      "label": "CEC",
      "nFeatures": 825,
      "classes": [
        {
          "cls": "SSURGO (soil)",
          "pct": 38.4,
          "n": 21,
          "subs": [
            {
              "sub": "Series",
              "pct": 6.9
            },
            {
              "sub": "Map unit",
              "pct": 6
            },
            {
              "sub": "CEC",
              "pct": 5.7
            },
            {
              "sub": "OM",
              "pct": 5.6
            }
          ]
        },
        {
          "cls": "Weather / climate",
          "pct": 30.4,
          "n": 575,
          "subs": [
            {
              "sub": "Precip",
              "pct": 5.8
            },
            {
              "sub": "Solar",
              "pct": 4.3
            },
            {
              "sub": "Deriv",
              "pct": 4
            },
            {
              "sub": "GDD",
              "pct": 3.6
            }
          ]
        },
        {
          "cls": "NDVI / vegetation",
          "pct": 13.9,
          "n": 31,
          "subs": [
            {
              "sub": "Prev fall",
              "pct": 2.5
            },
            {
              "sub": "Integral",
              "pct": 2.3
            },
            {
              "sub": "Peak",
              "pct": 2.3
            },
            {
              "sub": "Spring",
              "pct": 2.2
            }
          ]
        },
        {
          "cls": "Topographic",
          "pct": 12.2,
          "n": 15,
          "subs": [
            {
              "sub": "HAND",
              "pct": 3.7
            },
            {
              "sub": "Wetness",
              "pct": 2.5
            },
            {
              "sub": "Aspect",
              "pct": 1.4
            },
            {
              "sub": "Elevation",
              "pct": 1.2
            }
          ]
        },
        {
          "cls": "Cover crop",
          "pct": 2.6,
          "n": 11,
          "subs": [
            {
              "sub": "Prob",
              "pct": 1.7
            },
            {
              "sub": "Window",
              "pct": 0.6
            },
            {
              "sub": "Cover",
              "pct": 0.3
            }
          ]
        },
        {
          "cls": "Crop history (CDL)",
          "pct": 1.6,
          "n": 12,
          "subs": [
            {
              "sub": "CDL",
              "pct": 0.4
            },
            {
              "sub": "Distinct",
              "pct": 0.4
            },
            {
              "sub": "Rotation",
              "pct": 0.4
            },
            {
              "sub": "Crop",
              "pct": 0.3
            }
          ]
        },
        {
          "cls": "Machine data",
          "pct": 0.9,
          "n": 160,
          "subs": [
            {
              "sub": "Seedrate",
              "pct": 0.3
            },
            {
              "sub": "Moisture",
              "pct": 0.2
            },
            {
              "sub": "Appl",
              "pct": 0.2
            },
            {
              "sub": "Yield",
              "pct": 0.1
            }
          ]
        }
      ]
    }
  ]
}
